import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DataCollection from '../../shared/DataCollection';
import Patch from '../../utils/Patch.js';
import RanchCardList from './RanchCardList.js';

const TextInput = ({ value, onBlur }) => {
  const [current, setCurrent] = useState(value || '');
  return (
    <input
      type="text"
      value={current}
      style={{ width: '100%' }}
      onChange={(e) => setCurrent(e.target.value)}
      onBlur={(e) => { if (e.target.value !== value) onBlur(e); }}
    />
  );
};

const ListRanches = () => {
  const { t } = useTranslation();
  const [refreshKey, setRefreshKey] = useState(0);

  const onChange = (e, field, id) => {
    Patch('ranches', id, field, e.target.value,
      () => setRefreshKey(k => k + 1),
      () => {}
    );
  };

  const columns = [
    {
      name: '#',
      selector: row => row.ranch_number,
      sortable: true,
      width: '60px',
      cell: row => <span>{row.ranch_number}</span>,
    },
    {
      name: t('ranch_name'),
      selector: row => row.name,
      sortable: true,
      grow: 2,
      cell: row => (
        <TextInput
          value={row.name}
          onBlur={(e) => onChange(e, 'name', row._id)}
        />
      ),
    },
    {
      name: t('address'),
      selector: row => row.address,
      grow: 3,
      cell: row => (
        <TextInput
          value={row.address || ''}
          onBlur={(e) => onChange(e, 'address', row._id)}
        />
      ),
    },
    {
      name: t('nickname'),
      selector: row => row.nickname,
      grow: 1,
      cell: row => (
        <TextInput
          value={row.nickname || ''}
          onBlur={(e) => onChange(e, 'nickname', row._id)}
        />
      ),
    },
  ];

  return (
    <DataCollection
      key={refreshKey}
      collection="ranches"
      columns={columns}
      mobileComponent={(data, onRefresh) => (
        <RanchCardList data={data} onRefresh={onRefresh} />
      )}
    />
  );
};

export default ListRanches;
